import { render } from "./ThirdCut.vue?vue&type=template&id=6cc1b4d7&scoped=true"
import script from "./ThirdCut.vue?vue&type=script&lang=js"
export * from "./ThirdCut.vue?vue&type=script&lang=js"

import "./ThirdCut.vue?vue&type=style&index=0&id=6cc1b4d7&lang=sass&scoped=true"

import exportComponent from "/Users/jiun/Documents/case/2021/BMW/testing/filter/bmw_teaser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc1b4d7"]])

export default __exports__